import { createSlice } from "@reduxjs/toolkit";

import { EditState } from "../../model";

const initialState: EditState = {
  btnContent: "Submit",
  stagedJob: null,
};

const editSlice = createSlice({
  name: "edit",
  initialState,
  reducers: {
    changeTextContent: (state) => {
      state.btnContent = "Submit";
    },
    textToUpdate: (state) => {
      state.btnContent = "Update";
    },
  },
});

export const { changeTextContent, textToUpdate } = editSlice.actions;

export default editSlice.reducer;
